import React from 'react';
import { useTranslation } from 'react-i18next';

import ZLSection from '../../containers/zl-section/zl-section';
import CurrencyPicker from '../../components/currency-picker/currency-picker';


export interface ICurrencyPickerSectionProps {
    active: boolean;
    scrollTo?: boolean;
}

const CurrencyPickerSection: React.FunctionComponent<ICurrencyPickerSectionProps> = (props) => {
    const { t } = useTranslation();
    const { active, scrollTo } = props;

    const sectionTitle = t('globalGiftVouchers.currencyPicker.PleasePick');

    return (
        <ZLSection title={sectionTitle} active={active} scrollTo={scrollTo}>
            <CurrencyPicker />
        </ZLSection>
    );
};

export default CurrencyPickerSection;
